<template>
  <div class="scene-conatiner">
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
import { SceneManager } from './utils/Scene';

export default {
  props: {
    background: String,
    polygons: {
      type: Array,
      default: () => []
    },
    designWidth: {
      type: Number,
      default: 1200
    },
    designHeight: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {};
  },
  methods: {
    init() {
      const scene = new SceneManager('canvas', [this.designWidth, this.designHeight]);
      this.$scene = scene;

      scene
        // .setupPointerPosControl()
        .setupDragAndZoomControls()
        .setupShapeCreation()
        // .setupMarkerControls()
        .setBackground(this.background)
        .addShapes(this.polygons)
        .startRenderLoop(5);
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.$scene.dispose();
  }
};
</script>

<style lang="scss">
.scene-conatiner {
  width: 100%;
  height: 100%;

  position: relative;

  #canvas {
    width: 100%;
    height: 100%;
  }

  .css-marker {
    &:hover {
      z-index: 9999 !important;
    }
  }
}
</style>
